module.exports = __webpack_public_path__ + "static/media/todd_mitchell.d4233da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/collections/altolans/images/todd_mitchell.jpg
// module id = 993
// module chunks = 0